import { loadBoardMetadata, updateBoardMetadata } from "../repo/board-meta.js";
import type { ExecutionContext } from "../runtime/context.js";
import type {
  DictGetAllRequest,
  DictGetRequest,
  DictSetRequest,
  DictUnsetRequest,
} from "../cli/protocol.js";

export async function handleDictGet(
  context: ExecutionContext,
  request: DictGetRequest,
) {
  const board = await loadBoardMetadata(context, request.s);
  return {
    key: request.k,
    value: board.dict[request.k],
  };
}

export async function handleDictGetAll(
  context: ExecutionContext,
  request: DictGetAllRequest,
) {
  const board = await loadBoardMetadata(context, request.s);
  return {
    dict: board.dict,
  };
}

export async function handleDictSet(
  context: ExecutionContext,
  request: DictSetRequest,
) {
  const board = await updateBoardMetadata(context, request.s, (metadata) => ({
    ...metadata,
    dict: {
      ...metadata.dict,
      [request.k]: request.v,
    },
  }));
  return {
    dict: board.dict,
  };
}

export async function handleDictUnset(
  context: ExecutionContext,
  request: DictUnsetRequest,
) {
  const board = await updateBoardMetadata(context, request.s, (metadata) => {
    const next = { ...metadata.dict };
    delete next[request.k];
    return {
      ...metadata,
      dict: next,
    };
  });
  return {
    dict: board.dict,
  };
}
